module.exports = __webpack_public_path__ + "img/category-popular.ad0c49fc.png";